import gql from 'graphql-tag'

export default gql`
	mutation exportCSB($cashRegisterId: ID, $date: DateTime, $type: csbExportType, $isTemporary: Boolean) {
		cashAssist {
			exportCSB(cashRegisterId: $cashRegisterId, date: $date, type: $type, isTemporary: $isTemporary) {
				key
			}
		}
	}
`
